import { render, staticRenderFns } from "./DetalhesVencedores.vue?vue&type=template&id=7cfd2b60&scoped=true"
import script from "./DetalhesVencedores.vue?vue&type=script&lang=ts"
export * from "./DetalhesVencedores.vue?vue&type=script&lang=ts"
import style0 from "./DetalhesVencedores.vue?vue&type=style&index=0&id=7cfd2b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfd2b60",
  null
  
)

export default component.exports